// Formats a number by adding spaces as thousand separators (e.g., 10000 -> 10 000)
export default function useFormatNumber(value: MaybeRef<unknown>): unknown {
  const val = unref(value)
  if (typeof val !== 'number' || isNaN(val)) {
    return val
  }
  const parts = val.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return parts.join('.')
}
